import React, {useState, useEffect, useRef, useContext} from 'react'
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { AuthContext } from "../../components/Auth/AuthDataProvider.jsx";
import Card from '../../components/Card/Card.jsx';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import OldTable from '../../components/Table/OldTable.jsx';
import CustomInput from '../../components/CustomFields/CustomInput.jsx';
import CustomSwitch from '../../components/CustomFields/CustomSwitch.jsx';
import CustomDialog from '../../components/Dialog/CustomDialog.jsx';
import CustomDialog2 from '../../components/Dialog/CustomDialog2.jsx';
import apiUtil from "../../api/apiUtil.jsx";
import Api from "../../api/api.jsx";
import ldsApi from '../../api/ldsApi.jsx';
import {RoleAccessService} from '../../data/role-access'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark, faMagnifyingGlass, faPlus, faEye, faFilePdf, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import evfyLogoDriver from '../../assets/img/evfy-logo-driver.png'
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import dataUrlToBlob from 'dataurl-to-blob' 
import CustomDateRangePicker from '../../components/CustomFields/CustomDateRangePicker.jsx';
import CustomCheckbox from '../../components/CustomFields/CustomCheckbox.jsx';
import moment from 'moment';

/**
 * 
 * update on input type number change. 
 * dedicated component, so the whole table won't be refreshed
 */
export const DriverPayout = props => {
  const refTableSearch = useRef();
  const refTable = useRef();
  let grantedAccess = new RoleAccessService();
  let role = window.localStorage.getItem('uniqueRolePermissions');
  // const { currentRole } = this.context;
  let currentRole = window.localStorage.getItem('current_role');
  let userInfo = JSON.parse(window.localStorage.getItem('user')).result

  const { accessToken } = useContext(AuthContext)
 
  const [page, setPage] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [total, setTotal] = useState(0);
  const [rowData, setRowData] = useState(null);
  const [workers, setWorkers] = useState(0)
  const [limit, setLimit] = useState(20);
  const [openDialog, setOpenDialog] = useState(false);
  const [payoutDialog, setPayoutDialog] = useState(false);
  const [openDialogItem, setOpenDialogItem] = useState(null);
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [driver_id, setDriverId] = useState('')
  const [billed_date, setBillingDate] = useState(null)
  
  const [isUploading, setIsUPloading] = useState(false)
  const [progress, setProgress] = useState(null)
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false)

  const [rangeDate, setRaneDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [vendors, setVendors] = useState([])
  const [isVendor, setIsVendor] = useState(true)
  
  const [pdfUrl, setPdfUlr] = useState(null)
  const [openInvoicePreviewDialog, setOpenInvoicePreviewDialog] = useState(false)
  const [invoicePhone, setInvoicePhone] = useState([])
  const [invoiceEmail, setInvoiceEmail] = useState(null)
  const [invoiceNumber, setInvoiceNumber] = useState(null)
  const [invoiceNew, setInvoiceNew] = useState(null)
  const [previewData, setPreviewData] = useState(null)
  const [includeFailedJob, setIncludeFailedJob] = useState(true)
  let grantedMenu = new RoleAccessService();

 


  /* API */
  useEffect(() => {
    callReadApi();
    callWorkerApi()
    //callVendorReadApi()
  }, [])

  const callReadApi = (search = '' , page = '', size = '') => {
    let changePage = page;
    let changeSize = size;
    setIsInvoiceLoading(true)
    let param = {
        page: changePage != ''? changePage : page,
        take: changeSize != ''? changeSize : limit,
        search: search ? search.trim() : search,
        driver: true,
        sort: "latest"
      };

      ldsApi.read("client_driver_billings", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          setData(result)
          setTotal(data.total)
          setIsInvoiceLoading(false)
          }, (error, type) => {
            apiUtil.toast(error,  'warning', 'error')
            setIsInvoiceLoading(false)
          });
      });
  }

   /* VENDOR API */
   const callVendorReadApi = (search = '', callback = null) => {

      let param = {
        is_active: true,
      };
      // setIsInvoiceLoading(true)

      Api.read('vendors/active_vendor', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            let result = (data.result && data.result.length > 0) ? data.result : [];

            let arr = [];
            if(result && result.length > 0){
              arr = result.map((item, i) => {
                let value = item.company_id;
                let label = item.company_name && item.company_name;

                if(arr.findIndex(x => x.value === value) === -1){
                  return {
                    value: value,
                    label: label,
                    item: item
                  }
                } else {
                  return null;
                }
              });
             setVendors(arr.sort((a, b) => {
              const nameA = a.label?.toUpperCase(); // ignore upper and lowercase
              const nameB = b.label?.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
            
              // names must be equal
              return 0;
            }))
             
            } else {
                if(callback){
                  callback([]);
                }

            }
            // setIsInvoiceLoading(false)
          }, (error, type) => {
              if(callback){
                callback([]);
              }
              // setIsInvoiceLoading(false)
          });
      });
  }
  /* END VENDOR API */

  const callWorkerApi = (search = '' ) => {


     let param = {
        disabled: false,
        search: search ? search.trim() : search,
        is_truck_driver: true,
        light_data: true,
      };
    
      setIsLoading(true);
      
      Api.read('workers', param, accessToken).then( (results) => {
          apiUtil.parseResult(results, (data) => {
            const dataArr = (data.result && data.result.length > 0) ? data.result : []
            setWorkers(dataArr.sort((a, b) => {
              const nameA = a.first_name?.toUpperCase(); // ignore upper and lowercase
              const nameB = b.first_name?.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
            
              // names must be equal
              return 0;
            }));
            setIsLoading(false);
          }, (error, type) => {
            setWorkers([]);
            setIsLoading(false);
          });
      });
  }

  const callCreateApi = (callback = null, is_preview = null) => {
    setIsLoading(true)
    let start_date = startDate ? moment(startDate).format(apiUtil.getDefaultDateFormat()) : '';
    let end_date = endDate ? moment(endDate).format(apiUtil.getDefaultDateFormat()) : '';
    let params = {
      driver_id: driver_id,
      due_date: billed_date,
      pdf_url:  pdfUrl,
      start_date: start_date,
      end_date: end_date,
      is_vendor: isVendor,
      is_preview: is_preview,
      invoice_number: (invoiceNew == invoiceNumber) ? '' : invoiceNumber,
      invoice_phone: invoicePhone,
      invoice_email: invoiceEmail,
      include_failed_job: includeFailedJob
    }
    ldsApi.create('client_driver_billings', params, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {

        
        if(callback){
          callback(data);
        }
        setIsLoading(false)
      }, (error, type) => {
        setIsLoading(false)
        if(error && error !== ''){
            apiUtil.toast(error, 'warning', 'error');
        }
        if(callback){
          callback();
        }
      });
  });
  }
  
  const callUpdateIsActiveApi = (row, callback = null) => {
    setIsLoading(true)
    let params = {
      is_paid: row.is_paid
    }
    ldsApi.update('client_driver_billings/' + row.id, params, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {
        if(callback){
          callback();
        }
        setIsLoading(false)
      }, (error, type) => {
        setIsLoading(false)
      });
  });
  }

  const callDeleteApi = (row, callback = null) => {
    setIsLoading(true);
    let param = {
      destroy_all: true,
    };
    ldsApi.delete('client_driver_billings/' + row.id, param, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {
        setIsLoading(false);
        if(callback){
          callback();
        }
      }, (error, type) => {
        setIsLoading(false);
        if(callback){
          callback();
        }
      });
  });
  }
  
  
 


 /* TABLE */
 const CustomTable = () => {
    return <OldTable 
      ref={refTable}
      isLoading={isInvoiceLoading}
      className={'job-table-list' }  
      limit={limit}
      isDraggable={false}
      // grouping={true}
      page={page}
      total={total}
      defaultExpanded={true}
      selection={true}
      data={data}
      onPageChange={(page, size) => {
        setLimit(size);
        setPage(page);
        callReadApi( searchVal, page, size);
      }}
      onSelectionChange={(rows, column)=>{
        setRowData(rows);
      }}
      // Toolbar={customToolbar}
      columns={[
        { 
          title: "DP Name", 
          field: "dp_name",
          customSort: (a,b) => (a.driver && a.driver.first_name ? a.driver.first_name : '').toString().toLowerCase().trim().localeCompare((b.driver && b.driver.first_name? b.driver.first_name : '').toString().toLowerCase().trim()),
          cellStyle: {
            minWidth: 230,
            maxWidth: 230            
          },
          render: (row, type) => {
            if(type === 'row'){
              if(row.vendor) {
                return <span style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>{row.vendor.company_name.replace(/\s/g, '\u00A0')}</span>
              }
              return <span style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>{(row && row.driver && row.driver.first_name ) ? row.driver.first_name.replace(/\s/g, '\u00A0')+' '+( row.driver.last_name ? row.driver.last_name.replace(/\s/g, '\u00A0') : '') : ''}</span>;
            } else {
              return row;
            }
          }
        },  
        { 
          title: "Email Address", 
          field: "email",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200            
          },
          render: (row, type) => {
            if(type === 'row'){
              return <span className='none-backgroud-color' style={{ width:145, overflowWrap: 'break-word', display:'inline-block'}}>{(row && row.email) ? row.email : ''}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Statement Number", 
          field: "invoice_number",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200            
          },
        },
        { 
          title: "Phone Number", 
          field: "phone_number",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200            
          },
          customSort: (a,b) => (a.driver && a.driver.contact_no ? a.driver.contact_no : '').toString().toLowerCase().trim().localeCompare((b.driver && b.driver.contact_no? b.driver.contact_no : '').toString().toLowerCase().trim()),
          render: (row, type) => {
            if(type === 'row'){
              if(row.vendor) {
                return row.vendor.contact_no
              }
              return (row && row.driver ) ? row.driver.contact_no : '';
            } else {
              return row;
            }
          }
        },
        { 
          title: "Name of Bank", 
          field: "name_of_bank",
          cellStyle: {
            minWidth: 180,
            maxWidth: 180            
          },
          render: (row, type) => {
            if(type === 'row'){
              if(row.company_vendor) {
                let extra_data = row.company_vendor.extra_data ? JSON.parse(row.company_vendor.extra_data) : ''
                return extra_data && extra_data['name_of_bank'] ? extra_data['name_of_bank'] : ''
              }
              return ''
            } else {
              return row;
            }
          }
        },
        { 
          title: "Account No.", 
          field: "bank_account_detail",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200            
          },
          render: (row, type) => {
            if(type === 'row'){
              if(row.company_vendor) {
                let extra_data = row.company_vendor.extra_data ? JSON.parse(row.company_vendor.extra_data) : ''
                return extra_data && extra_data['account_number'] ? extra_data['account_number'] : ''
              }
              return ''
            } else {
              return row;
            }
          }
        },
        { 
          title: "Amount Paid", 
          field: "amount",
          cellStyle: {
            minWidth: 180,
            maxWidth: 180            
          },
          render: (row, type) => {
            if(type === 'row'){
              return (row && row.amount ) ? parseFloat(row.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            } else {
              return row;
            }
          }
        },
        { 
          title: "Payout Date", 
          field: "due_date",
          cellStyle: {
            minWidth: 140,
            maxWidth: 140            
          },
          render: (row, type) => {
            if(type === 'row'){
              if(row && row.due_date) {
                var splitdate = row.due_date.split(" ")
                return moment(splitdate[0]).format(apiUtil.getImportDateFormat());
              } else {
                return '';
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Paid?", 
          align: 'paid',
          cellStyle: {
            minWidth: 100,
            maxWidth: 100            
          },
          sorting: false,
          render: (row) => {
            return <Box>
              <Grid container justify={'center'}>
                <Box clone>
                  <Grid item xs={'auto'}>
                  <CustomSwitch 
                      checked={row.is_paid}
                      disabled={!grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Edit') ? true: false}
                      onChange={(isChecked) => {
                        row.is_paid = isChecked;
                        callUpdateIsActiveApi(row, () => {
                          callReadApi();
                          apiUtil.toast('Successfully Updated!', 'check_circle');
                        });
                      }}
                    />
                  </Grid>
                </Box>
              </Grid>
            </Box>
          }
        },
        { 
          title: "Actions",
          field: "actions",
          cellStyle: {
            minWidth: 180,
            maxWidth: 180,
          },
          // align: 'center',
          sorting: false,
          render: (row) => {
            return <Container fluid className="d-flex justify-content-around">
                  <a className="text-decoration-none" 
                  href={row.pdf_url} 
                  target={"_blank"}
                  >
                  <FontAwesomeIcon icon={faFilePdf} style={{fontSize:"18px", color : row.pdf_url ? "#007cde" :"#007cdea3"}} /></a>
                  {grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Details') && <FontAwesomeIcon icon={faEye} style={{fontSize:"18px"}}
                  onClick={()=> {
                    let data = row.vendor ? row.vendor.company_name + row.invoice_number : row.driver.first_name+' '+row.driver.last_name+' '+ row.invoice_number;
                      props.history.push({
                        pathname: '/invoice/driver/details',
                        state: {
                          id: row.id,
                          // orders: row.orders,
                          dp_name: data
                        }
                      });
                   }
                  } 
                  className="primary-color"/>}
                  {grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Delete') && currentRole != "BD Admin" &&  <span
                onClick={()=>{
                  setOpenDialog(true)
                  setOpenDialogItem(row)
                }}
                ><FontAwesomeIcon icon={faTrashCan} style={{fontSize:"18px"}} className="danger-color"/></span>}
            </Container>
          }
        },
      ]}
    />
  }

  /* EXPORT */
  const callExportDriverInvoicePDF = () => {

    let pdf = new jsPDF("p", "mm", "a4");

    let index = 0;
    // let data = row?[row]:this.state.data;  
    
      if(index!= 0 ){  pdf.addPage(); }
        pdf.addImage(evfyLogoDriver, 'PNG',10,8, 60, 22);
        pdf.setFont("verdana","bold","800");
        pdf.setFontSize(12);
        pdf.text(110,12, 'Evfy Pte Ltd');  

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,17, "84 Genting Lane");
        pdf.text(110,22, "#02-02");
        pdf.text(110,27, "Singapore 349584");
        pdf.text(110,32, "ACRA No.: 202121256D");
        pdf.text(110,37, "Email: finance@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(10);
        pdf.setFont("verdana","bold","800");
        pdf.text(10,38, 'Name'); 
        pdf.text(10,43, 'Email'); 
        let primary_address_1 = "Primary Address Line 1		";
        let primary_address_2 = "Primary Address Line 2		";
        let primary_address_3 = "Primary Address Line 3		";
        pdf.text(10,48, 'Contact No: ' + primary_address_1); 
        pdf.text(10,53, 'Name of Bank: '+ primary_address_2); 
        pdf.text(10,58, 'Name of Account: '+ primary_address_3); 
        pdf.text(10,63, 'Account No: '+ primary_address_3); 
        pdf.text(10,68, 'Business Name(if Any): '+ primary_address_3); 

        // pdf.setFontSize(8);
        // pdf.setFont("verdana","normal","400");
        // pdf.text(110,37, "Email: finance@evfy.sg");
        // pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(140,53, "From");
        pdf.text(170,53, "To");

        pdf.setFont("verdana","bold","800");
        pdf.text(110,58, "Period:");
        pdf.text(110,63, "Statement Number:");
        pdf.text(150,63, "	EVFY_year/mth/running no.	");
        pdf.text(110,68, "Statement Date:");

        pdf.autoTable({ 
          head: [ [{content: 'Delivery statement', colSpan:8,
                  styles: { halign: "center"}}],
                ['S/N', 'Date', 'Job Number', 'Item', 'Qty', 
                'Base payout (SGD)', 'Additional (SGD)', 'Amount (SGD)']],
          body: [
            ['1', '', '', '', '', '' ,'', '$0.0'],
            ['2', '', '', '', '', '' ,'', '$0.0'],
            ['3', '', '', '', '', '' ,'', '$0.0'],
            ['4', '', '', '', '', '' ,'', '$0.0'],
            ['5', '', '', '', '', '' ,'', '$0.0'],
            [{content: 'This is an auto-generated statement by Evfy Pte Ltd. For discrepencies, please contact us at finance@evfy.sg', colSpan:6, 
            styles: { halign: "left", lineWidth: 0 }},
            {content: 'Subtotal', colSpan:1, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'GST', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'AMOUNT DUE TO US', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
          ],
          margin: { horizontal: 10, top: 75 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top", halign: "center" },
          headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
          columnStyles: { email: { columnWidth: "wrap" } },
          theme: "grid",
            });

        pdf.save(`Invoice.pdf`);
  }
  /* END EXPORT */


  /* DIALOG */
  const CustomDialogPopup = () => {
    return <CustomDialog 
      open={openDialog}
      title={'Delete'}
      onClose={() => {
        setOpenDialog(false);
        setOpenDialogItem(null);
      }}
      onOk={() => {
        setOpenDialog(false);
        let row = openDialogItem; 
        callDeleteApi(row, () => {
          setOpenDialogItem(null);
          callReadApi(searchVal);
          apiUtil.toast('Successfully Deleted', 'check_circle');
          // });
        });
      }}
    >
      {/* add openDialog item worker name */}
      <Box>Are you sure you want to delete?</Box>
    </CustomDialog>
  }
  /* END DIALOG */


  const callUploadFilesApi = async (file, fName) => {

    let result = "";

    setIsUPloading(true)
    setProgress(0)

    if(file){
        let fileExt = fName.split('.').pop();
        let filename = fName.substr(0, fName.lastIndexOf("."))
        
        let getResult = await Api.uploadFile(
            'upload',
            file, 
            'AUTH',
            'driver/invoices', 
            filename,
            fileExt,
            accessToken, 
            (progress) => {
                setProgress(progress)
            }
        );

        apiUtil.parseResult(getResult, (data) => {
          if(data.status) {
            setPdfUlr(data.result.image_medium_url)
          }
        }, (error) => {
            apiUtil.toast(error, 'check_circle', 'error');
        });

        setIsUPloading(false)
        setProgress(null)
    } else {
        apiUtil.toast('Please select a file!', 'check_circle', 'error');
    }

    return result;
  }
  
  const invoicePreviewDialog = () => {
    return <CustomDialog
            open={openInvoicePreviewDialog}
            maxWidth={"md"}
            title={"Invoice Preview"}
            isLoading={isLoading}
            onClose={() => {
              setInvoicePhone(null)
              setInvoiceEmail(null)
              setInvoiceNumber(null)
              setInvoiceNew(null)
              setPreviewData(null)
              setOpenInvoicePreviewDialog(false);
            }}
            onOk={() => {
              callCreateApi((result)=> {
                if(result) {
                  apiUtil.toast("Successfully Created", "check_circle")
                  setInvoicePhone(null)
                  setInvoiceEmail(null)
                  setInvoiceNumber(null)
                  setInvoiceNew(null)
                  setPreviewData(null)
                  setOpenInvoicePreviewDialog(false)
                  setPayoutDialog(false);
                  setDriverId(null)
                  setBillingDate(null)
                  setPdfUlr(null)
                  setPayoutDialog(false)
                  setRaneDate(null)
                  setStartDate(null)
                  setEndDate(null)
                  callReadApi()

                }
              })
            }}
            >
              <Box>
              <Row className='mb-4'>
                <Col xs={12} md={6} >
                  <div>
                      { userInfo && userInfo.company_logo ? <img src={ userInfo.company_logo } alt="company logo" style={{height: '120px'}}/>
                      : <div style={{fontSize: "50px"}}>LOGO</div>}

                  </div>
                  <div className='mt-5'>
                  <div className='report-header'>{previewData && previewData.driver ? `${previewData.driver.first_name} ${previewData.driver.last_name}` :previewData && previewData.vendor ? previewData.vendor.company_name : '' }</div>
                  <div className='my-2'>
                    <CustomInput type="text" name="" className='col-6' placeholder='phone number'
                    value={invoicePhone}
                    onChange={e=>(setInvoicePhone(e.target.value))}
                    />
                  </div>
                  <div className='my-2'>
                    <CustomInput type="email" name="" className='col-6'  placeholder='Email'
                    value={invoiceEmail}
                    onChange={e=>setInvoiceEmail(e.target.value)}
                    />
                  </div>
                  <div className='my-2'>
                    <span>{previewData && previewData.vendor  && previewData.vendor.extra_data && JSON.parse(previewData.vendor.extra_data)['name_of_bank'] ? JSON.parse(previewData.vendor.extra_data)['name_of_bank'] : "Name of Banks :"}</span>
                  </div>
                  <div className='my-2'>
                    <span>{previewData && previewData.vendor  && previewData.vendor.extra_data && JSON.parse(previewData.vendor.extra_data)['account_number'] ? JSON.parse(previewData.vendor.extra_data)['account_number'] : isVendor ? "Account Number :" : "Name of Account :"}</span>
                  </div>
                  <div className='my-2'>
                    {isVendor ? "" : <span>{previewData && previewData.driver  && previewData.driver.bank_account_detail ? previewData.driver.bank_account_detail  : "Bank Account Detail:" }</span>}

                  </div>
                  <div className='my-2'>
                    <span>Business Name (if Any) :</span>
                  </div>
                  </div>
                </Col>
                <Col xs={12} md={6} >
                  <div>
                  <div className='report-header'>{userInfo ? userInfo.company_name : '' }</div>
                  <div >{userInfo && userInfo.address ? userInfo.address.split(',')[0] : '' }</div>
                  <div >{userInfo && userInfo.address ? userInfo.address.split(',')[1] : '' }</div>
                  <div >{userInfo && userInfo.address ? userInfo.address.split(',')[2] : '' }</div>
                  <div >{userInfo && userInfo.address ? userInfo.fax_no : '' }</div>
                  <div >Email : {userInfo ? userInfo.email: '' } </div>
                  <div >Phone : {userInfo ? userInfo.contact_no: '' } </div>
                  </div>
                  <div className='mt-5'>
                    <table style={{width: "80%"}}>
                      <tr>
                        <td></td>
                        <td className='report-header' style={{width: "30%"}}>From</td>
                        <td className='report-header' style={{width: "30%"}}>To</td>
                      </tr>
                      <tr>
                        <td className='report-header'>Peroid:</td>
                        <td >{moment(startDate).format(apiUtil.getImportDateFormat())}</td>
                        <td>{moment(endDate).format(apiUtil.getImportDateFormat())}</td>
                      </tr>
                      <tr>
                        <td className='report-header'>Statement Number:</td>
                        <td colSpan={2}>
                          <CustomInput type="text" placeholder='Invoice Number' 
                            value={invoiceNumber}
                            onChange={e=>{
                              setInvoiceNumber(e.target.value)
                            }
                          }
                        />
                        </td>
                      </tr>
                      <tr>
                        <td className='report-header'>Statement Date</td>
                        <td colSpan={2}> {billed_date ? moment(billed_date).format(apiUtil.getImportDateFormat()) : moment().format(apiUtil.getImportDateFormat()) }</td>
                      </tr>
                    </table>
                    <div className='col-4'></div>
                  </div>

                </Col>
                <Col xs={12} md={12} className='mt-4 pe-4'>
                <CustomInvoiceTable/>
                </Col>
              </Row>
                
              </Box>

              

            </CustomDialog>
  }

  const getQty = (packages) => {
    let qty = 0
    if (packages.length > 0 ) {
      packages.forEach(pp => {
        qty += pp.package_quantity
      })
    }

    return qty
  }
  const CustomInvoiceTable = () => {
    
    return <table className='custom-invoice-table'>
      
      <tr className='report-header'>
        <td colSpan={5}>Delivery Statement</td>
      </tr>
      <tr className='report-header'>
        <td>S/N</td>
        <td>Description</td>
        <td>Price (S$)</td>
        <td>Qty</td>
        <td>Amount (S$)</td>
      </tr>
      {previewData && <tr>
        <td>1</td>
        <td>Delivery Service for {moment(startDate).format(apiUtil.getImportDateFormat())} - {moment(endDate).format(apiUtil.getImportDateFormat())}</td>
        <td>{previewData && previewData.invoice_amount && parseFloat(previewData.invoice_amount) > 0 ? apiUtil.getCurrencyFormat(previewData.invoice_amount) : '-' }</td>
        <td>1</td>
        <td>{previewData && previewData.invoice_amount && parseFloat(previewData.invoice_amount) > 0 ? apiUtil.getCurrencyFormat(previewData.invoice_amount) : '-' }</td>
       </tr>
      }
      {previewData && <tr>
        <td>2</td>
        <td>Volume Discount {previewData && previewData.discount ? "( " + previewData.discount + " )  " : '-' } </td>
        <td>-</td>
        <td>1</td>
        <td>-</td>
       </tr>
      }
      <tr>
        <td colSpan={4} className="botom-cell-style">Subtotal</td>
        <td>{previewData && previewData.invoice_amount && parseFloat(previewData.invoice_amount) > 0 ? apiUtil.getCurrencyFormat(previewData.invoice_amount) : '-' }</td>
      </tr>
      <tr>
        <td colSpan={4} className="botom-cell-style">AMOUNT DUE FROM US</td>
        <td>{previewData && previewData.invoice_amount && parseFloat(previewData.invoice_amount) > 0 ? apiUtil.getCurrencyFormat(previewData.invoice_amount) : '-' }</td>
      </tr>
    </table>
  }

  const NewPayoutDialog = () => {
    // console.log(openDialogItem)
    return <CustomDialog2 
      open={payoutDialog}
      title={'Create New Driver Statement'}
      zIndexNumber={"z-index-1200"}
      hideCancelButtons={true}
      maxWidth={'md'}
      onClose={() => {
        setPayoutDialog(false);
        setDriverId(null);
        setBillingDate(null)
        setPdfUlr(null)
        setRaneDate(null)
        setStartDate(null)
        setEndDate(null)
      }}
      onOk={() => {

        if(driver_id == '') {
          apiUtil.toast('Please select a driver!', 'check_circle', 'error')
          return
        }

        callCreateApi(()=>{
          callReadApi()
        })
        setPayoutDialog(false);
        setDriverId(null);
        setBillingDate(null)
        setPdfUlr(null)
        setRaneDate(null)
        setStartDate(null)
        setEndDate(null)
      }}
      hideOkButtons={true}
    >
      {/* add openDialog item worker name */}
      <Box>
        <Row>
          <Col xs={12} md={6} className="d-flex justify-content-start py-2 w-75 max-xs-width-control-900 align-items-center">
            <div className="col-12 col-xs-12 col-md-4 col-lg-3 text-end max-xs-width-control-900">DP Name</div>
            <div className="col-12 col-xs-12 col-md-4 col-lg-5 max-xs-width-control-900"> 
              <Form.Select aria-label="Default select example" className='ms-2' style={{width: '90%'}}
              disabled={isUploading? isUploading: isLoading? isLoading: false}
              onChange={e=> {
                let driver_id = e.target.value
                if(workers.filter(wo => wo.id == driver_id).length > 0 ) {
                  setIsVendor(false)
                } else {
                  setIsVendor(true)
                }
                setDriverId(driver_id)
              }}
              >
                <option value="">Select Driver</option>
                {workers.length > 0 && workers.map((worker)=> (
                    <option value={worker.id} key={worker.id}>{worker.first_name? worker.first_name.replace(/\s/g, '\u00A0'): '' } {worker.last_name? worker.last_name.replace(/\s/g, '\u00A0'): '' }</option>
                ))}
                {vendors.length > 0 && vendors.map((vendor)=> (
                  <option value={vendor.value} key={vendor.value}>{vendor.label}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-12 col-xs-12 col-md-3 col-lg-3 align-items-center position-relative px-2 mt-3 px-sm-2 mt-sm-3 px-md-2 mt-md-3 mt-lg-0 px-lg-0 mt-xl-0 px-xl-0">
                <span style={{ fontWeight: 'bold'}}>include failed jobs?</span>  
                <span style={{position:'absolute', right: '-5px', top: '-10px'}}>
                <CustomCheckbox 
                  value={includeFailedJob}
                  checked={includeFailedJob}
                  onChange={e => {
                    setIncludeFailedJob(!includeFailedJob)
                  }}
                />             
                </span>                
            </div>
          </Col>
          </Row>
          <Row>
          <Col xs={12} md={6} className="d-flex justify-content-start py-2 w-75 max-xs-width-control-900 align-items-center">
            <div className="col-12 col-xs-12 col-md-4 col-lg-3 text-end max-xs-width-control-900">Statement Date</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-9 max-xs-width-control-900"> 
            <input type="date" className="form-control ms-2 w-50" 
             disabled={isUploading? isUploading: isLoading? isLoading: false}
             onChange={e=>{
              setBillingDate(e.target.value)
             }}
            />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} className="d-flex justify-content-start py-2 w-75 max-xs-width-control-900 align-items-center col-md-6 col-12">
              <div className="col-12 col-xs-12 col-md-4 col-lg-3 text-end max-xs-width-control-900">Invoice Period</div>
              <div className="col-12 col-xs-12 col-md-8 col-lg-8 ps-1 max-xs-width-control-900">
              <CustomDateRangePicker
                  className="w-100"
                  disabled={pdfUrl || isUploading || isLoading? true: false}
                  range={rangeDate}
                  onChange={(range) => {
                    setRaneDate(range)
                    setStartDate(range.startDate)
                    setEndDate(range.endDate)
                  }}
                />
                </div>
          </Col>
        </Row>
        
        <div style={{marginLeft:'50px'}}>or</div>
        <Row>
        <Col xs={12} md={6} className="d-flex justify-content-start py-2 w-75 max-xs-width-control-900 align-items-center col-md-6 col-12">
          <div className="col-12 col-xs-12 col-md-4 col-lg-3 text-end max-xs-width-control-900">Upload CSV or Excel file:</div>
          <div className="col-12 col-xs-12 col-md-8 col-lg-8 ps-1 max-xs-width-control-900">
          <input type="file"  className="form-control flip-form"
            disabled={(startDate || endDate) || isLoading || isUploading ? true: false }
            accept="application/pdf"
            onChange={e=>{
              if(e.target.value !=='') {
                let file_name = e.target.files[0].name
                let reader = new FileReader();
                reader.onload = function(e) {
                  let result = e.target.result
                  let blob = dataUrlToBlob(result)
                  callUploadFilesApi(blob, file_name)
                };
                reader.readAsDataURL(e.target.files[0]);
              } else {
                setPdfUlr(null)
              }
              
            }}/></div>
          </Col>
        </Row>

         
          <Row>
              <Col  xs={12} className="d-flex justify-content-center max-xs-width-control-900 align-items-center text-center">
              <Button className="upload-style"
                  onClick={() => {
                    if(driver_id == null || driver_id == '') {
                      apiUtil.toast('Please select a driver!', 'check_circle', 'error')
                      return
                    }

                    if(startDate == null && pdfUrl == null) {
                      apiUtil.toast('Please select invoice period or upload PDF!', 'check_circle', 'error')
                      return
            
                    }
                    
                    let is_preview = pdfUrl ? false : true
            
                    callCreateApi((result)=>{
                      if(result) {
                        if (is_preview) {
                          setInvoicePhone(result.driver ? result.driver.contact_no : result.vendor ? result.vendor.contact_no : '')
                          setInvoiceEmail(result.driver ? result.driver.email : result.vendor ? result.vendor.email : '')

                          setInvoiceNumber(result.invoice_number ? result.invoice_number : '')
                          setInvoiceNew(result.invoice_number ? result.invoice_number : '')
                          setPreviewData(result)
                          setOpenInvoicePreviewDialog(true)
                          return
                        }

                        callReadApi()
                        setPayoutDialog(false);
                        setDriverId(null);
                        setBillingDate(null)
                        setPdfUlr(null)
                        setRaneDate(null)
                        setStartDate(null)
                        setEndDate(null)
                        apiUtil.toast("Successfully Created", "check_circle")
                      }
                      
                    }, is_preview)
                    
                  }}
                  disabled={isUploading? isUploading: isLoading? isLoading: false}
                >{isUploading || isLoading? <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Generate Statement"}</Button>
              </Col>
          </Row>
      </Box>
    </CustomDialog2>
  }
  

  return <Container fluid>
     <Card className="overflow-hidden custom-card-margin-x">
          <div className="row border-0 m-0">
            <div className="col-xs-12 col-md-6 d-flex justify-content-start align-items-center mb-2">
            <div className="row d-flex max-xs-width-control justify-content-start align-items-center mb-2">
                <div className="col-xs-12 col-md-6 my-2">
                <CustomInput
                className="input-custom-style"
                ref={refTableSearch}
                  placeholder={'Search Driver'}
                  value={searchVal}
                  onChange={e=>{
                    setSearchVal(e.target.value)
                  }}
                  onPressEnter={(e) => {
                    setSearchVal(refTableSearch.current.state.value);
                    setPage(1);
                    callReadApi(searchVal, 1) 
                  }}
                />
                </div>
                <div className="col-xs-12 col-md-6 my-2 d-flex justify-content-center align-items-center">
                <Button className="upload-style w-100 max-height-btn" onClick={(e) => {
                        setPage(1);
                        callReadApi(searchVal, 1) 
                      }}><FontAwesomeIcon icon={faMagnifyingGlass} className="text-white" style={{color:'#ffffff'}}/> Search</Button>
                </div>
                </div>
            </div>
            <div className="col-xs-12 col-md-6 d-flex justify-content-end align-items-center mb-2">
              {/* <Button className="justify-self-end d-flex ms-auto upload-style-border cd-shadow">Import Customer</Button> */}
              {(grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Add') && currentRole != 'BD Admin' && currentRole != 'Ops Admin') &&  <Button className="justify-self-end upload-style" onClick={() => {
               setPayoutDialog(true)
              }}><FontAwesomeIcon icon={faPlus} /> New Statement</Button>}
            </div>
          </div>
      </Card> 

      {grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice List') && 
          <Card className="overflow-hidden custom-card-margin-x">
            <CustomTable /> 
          </Card>}
    <CustomDialogPopup />
    {NewPayoutDialog()}
    {invoicePreviewDialog()}
  </Container>;
}